/* Wondr Light - pause gallery videos when their slide scrolls out of view. */
(function () {
  'use strict';

  function pauseHidden(track) {
    var width = Math.max(track.clientWidth, 1);
    var active = Math.round(track.scrollLeft / width);
    track.querySelectorAll('[data-wonder-gal-slide]').forEach(function (slide, index) {
      if (index === active) return;
      var video = slide.querySelector('video');
      if (video && !video.paused) video.pause();
      var frame = slide.querySelector('iframe');
      if (frame && frame.src.indexOf('enablejsapi') === -1 && frame.dataset.wonderReset !== 'true') return;
    });
  }

  document.addEventListener(
    'scroll',
    function (event) {
      var track = event.target;
      if (!track || !track.matches || !track.matches('[data-wonder-gal-track]')) return;
      window.clearTimeout(track._wonderTimer);
      track._wonderTimer = window.setTimeout(function () {
        pauseHidden(track);
      }, 150);
    },
    true
  );
})();